import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Learning tasks for developers to understand the IBM middleware integration use cases on Red Hat OpenShift.`}</p>
    </PageDescription>
    <h3>{`Learning Tasks`}</h3>
    <p>{`This set of learning tasks focuses on using IBM middleware on Red Hat OpenShift.`}</p>
    <h2>{`Self-paced agenda to build and deploy an App Connect REST API workflow`}</h2>
    <p>{`This activity provides a working example of a Tekton based CICD pipeline to build and deploy an App Connect application invoking the REST API of the `}<a parentName="p" {...{
        "href": "https://github.com/ibm-garage-cloud/inventory-management-svc-solution"
      }}>{`Inventory Management Service`}</a>{`.
The Pipeline and Task resources available in the `}<a parentName="p" {...{
        "href": "https://cloudnativetoolkit.dev/"
      }}>{`Cloud Native Toolkit`}</a>{` can be used as a starting point to build BAR files for other ACE workflows.`}</p>
    <p>{`The activity consists of the following tasks:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#prerequisites"
        }}>{`Prerequisites`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#deploy-the-backend-inventory-management-service"
        }}>{`Deploy the Inventory Management Service`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#configure-the-app-connect-workflow"
        }}>{`Configure the App Connect workflow with the Inventory REST API URL`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#execute-the-app-connect-pipeline"
        }}>{`Execute the the App Connect pipeline to build and deploy the configured workflow`}</a></li>
    </ol>
    <h3><strong parentName="h3">{`Prerequisites`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Task`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Instructions`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Active OpenShift 4.x Cluster`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Set up accounts and tools`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/dev-guide/getting-started/prereqs"
            }}>{`Instructions`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Install the Cloud Native Toolkit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://cloudnativetoolkit.dev/getting-started-day-0/install-toolkit/quick-install"
            }}>{`Install the Cloud Native Toolkit`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Install IBM Cloud Pak for Integration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.ibm.com/docs/en/cloud-paks/cp-integration/2020.4?topic=installing"
            }}>{`Install Cloud Pak for Integration v2020.4`}</a></td>
        </tr>
      </tbody>
    </table>
    <h3><strong parentName="h3">{`Deploy the backend Inventory Management Service`}</strong></h3>
    <p>{`The image below depicts the Tekton pipeline executed.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.31944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABlElEQVQ4y6VTyXKCQBD1/7/HVDxluXnwlOUQg1WJxqoglDgw4zAbLz0NKKi3DPVoeD396GWYpIVGqSxq62FdYGjjoeoO2jEkWwulDPGu422L+F63eyZR6HJFUecMmiZ0TMN3rxTUy/uIGz4biptEZaaahsGB3uNzLVDK+uRj3jkYEu2lxCFDSehFY3K3BUOD31xC3/C1723mVfqM8vepI8O1YAiBrfUNtJKUkR21oheOl5QSpRAoij2qqmI/C2rTC7ZBxhiUR4k02eJYKgRyeOe5DfGDQ3gf7Tl7FtzuJdaFYCJZJfhYfsAEi0OhYK07ZR4x7OdwGCPBr8piKdvSHp4eMZvd87Y9laL18bQ5z3MIIUYCpxYMBeuu5LiUpGNBU6RKqMww6p+jCV9meWmvhnI+hx65THGsJabTO2p8gfl8jsViwf5+eDczjCeeN3GvWmdNvSvrA51DgdfXN2RZjiRZUX+XneBYLDR9HAnai9L+s+KHJt+pxO6gEf/piB1hmyusdxI/mcKG7CbaTPJz5G6ii/kDqTj2r7nRVbsAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Tekton pipeline",
        "title": "Tekton pipeline",
        "src": "/dev-guide/static/b76cf9eefda4c06b030fc54907935e0c/3cbba/CNTK-ACE-Pipelines_v1.0-Inventory-App.png",
        "srcSet": ["/dev-guide/static/b76cf9eefda4c06b030fc54907935e0c/7fc1e/CNTK-ACE-Pipelines_v1.0-Inventory-App.png 288w", "/dev-guide/static/b76cf9eefda4c06b030fc54907935e0c/a5df1/CNTK-ACE-Pipelines_v1.0-Inventory-App.png 576w", "/dev-guide/static/b76cf9eefda4c06b030fc54907935e0c/3cbba/CNTK-ACE-Pipelines_v1.0-Inventory-App.png 1152w", "/dev-guide/static/b76cf9eefda4c06b030fc54907935e0c/e8601/CNTK-ACE-Pipelines_v1.0-Inventory-App.png 1493w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open a terminal and log into your OpenShift cluster.  For IBM Cloud, navigate to your cluster in the `}<em parentName="p">{`IBM Cloud console`}</em>{`, click on the `}<strong parentName="p">{`Access`}</strong>{` tab, and follow the
instructions to log in to the cluster from the command line.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a development namespace.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`oc sync \${DEV_NAMESPACE} --dev
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open the Developer Dashboard.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`oc dashboard
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the Developer Dashboard, click on `}<strong parentName="p"><Globals name="templates" mdxType="Globals" /></strong>{` tab.  Click on the `}<strong parentName="p">{`Inventory Service`}</strong>{` tile to create your app github repository from the
template repository selected. You can also click on the `}<strong parentName="p">{`Git Icon`}</strong>{` to browse the source template repository and click on the `}<strong parentName="p">{`Template`}</strong>{` to create the template.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Complete the `}<a parentName="p" {...{
            "href": "https://help.github.com/en/github/creating-cloning-and-archiving-repositories/creating-a-repository-from-a-template"
          }}>{`GitHub create repository from template`}</a>{` process.`}</p>
        <p parentName="li"><strong parentName="p">{`Owner`}</strong>{`: Select a validate GitHub organization that you are authorized to create repositories within or the one you were given for the shared cluster (See warning above)`}</p>
        <p parentName="li"><strong parentName="p">{`Repository name`}</strong>{`: Enter a valid name for you repo, GitHub will help with showing a green tick if it is valid (See warning above)`}</p>
        <p parentName="li"><strong parentName="p">{`Description`}</strong>{`: Describe your app`}</p>
        <p parentName="li">{`Press `}<strong parentName="p">{`Create repository from template`}</strong>{` and the new repository will be created in your selected organization.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`With the browser open to the newly created repository, click on `}<strong parentName="p">{`Clone or download`}</strong>{` and copy the clone `}<em parentName="p">{`SSH link`}</em>{`, and use the `}<inlineCode parentName="p">{`git clone`}</inlineCode>{` command to clone it to your developer desktop machine.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`git clone git@github.com:{gitid}/inventory-management-svc-solution.git
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Change into the cloned directory.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`cd inventory-management-svc-solution
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set a basepath for the REST API for the Inventory Management Service.`}</p>
        <Tabs mdxType="Tabs">
          <Tab label="OpenShift 4.0 - 4.5" mdxType="Tab">
            <br />
            <ol parentName="li">
              <li parentName="ol">
                <p parentName="li">{`Edit `}<strong parentName="p">{`src/main/resources/application.yml`}</strong>{` and update the `}<em parentName="p">{`server`}</em>{` section to include the `}<inlineCode parentName="p">{`/api`}</inlineCode>{` base path to `}<em parentName="p">{`server.servlet.context-path`}</em>{`.`}</p>
                <pre parentName="li"><code parentName="pre" {...{
                    "className": "language-shell",
                    "metastring": "script",
                    "script": true
                  }}>{`server:
  port: \${PORT:9080}
  servlet:
    context-path: "/api"
`}</code></pre>
              </li>
            </ol>
            <br />
            <ol parentName="li" {...{
              "start": 2
            }}>
              <li parentName="ol">
                <p parentName="li">{`Edit the file `}<strong parentName="p">{`chart/base/values.yaml`}</strong>{` and set the `}<em parentName="p">{`route.path`}</em>{` from `}<inlineCode parentName="p">{`/`}</inlineCode>{` to `}<inlineCode parentName="p">{`/api`}</inlineCode>{`.`}</p>
                <pre parentName="li"><code parentName="pre" {...{
                    "className": "language-shell",
                    "metastring": "script",
                    "script": true
                  }}>{`route:
  enabled: false
  rewriteTarget: "/"
  path: "/api"
`}</code></pre>
              </li>
            </ol>
          </Tab>
          <Tab label="OpenShift 4.6+" mdxType="Tab">
            <br />
            <ol parentName="li">
              <li parentName="ol">
                <p parentName="li">{`Edit the file `}<strong parentName="p">{`chart/base/values.yaml`}</strong>{` and set the `}<em parentName="p">{`route.path`}</em>{` from `}<inlineCode parentName="p">{`/`}</inlineCode>{` to `}<inlineCode parentName="p">{`/api`}</inlineCode>{`.`}</p>
                <pre parentName="li"><code parentName="pre" {...{
                    "className": "language-shell",
                    "metastring": "script",
                    "script": true
                  }}>{`route:
  enabled: false
  rewriteTarget: "/"
  path: "/api"
`}</code></pre>
              </li>
            </ol>
          </Tab>
        </Tabs>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set the namespace context.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`oc project {DEV_NAMESPACE}
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Register the App in a DevOps Pipeline`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`  oc pipeline
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the `}<strong parentName="p">{`Tekton`}</strong>{` pipeline type.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The first time a pipeline is registered in the namespace, the CLI will ask for your username and
`}<strong parentName="p">{`Personal Access Token`}</strong>{` for the Git repository.  The credentials will be stored in a secret named `}<inlineCode parentName="p">{`git-credentials`}</inlineCode>{`. It will use the current branch.`}</p>
        <p parentName="li">{`  `}<strong parentName="p">{`Username`}</strong>{`: Enter your GitHub user id`}</p>
        <p parentName="li">{`  `}<strong parentName="p">{`Personal Access Token`}</strong>{`: Paste your GitHub personal access token`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When registering a `}<inlineCode parentName="p">{`Tekton`}</inlineCode>{` pipeline, you will also be prompted to select which pipeline you want to use for your application. Select `}<inlineCode parentName="p">{`ibm-java-gradle`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Y`}</inlineCode>{`/`}<inlineCode parentName="p">{`n`}</inlineCode>{` to enable the pipeline to scan the image for vulnerabilities.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Provide `}<inlineCode parentName="p">{`/api/health`}</inlineCode>{` as the health endpoint.  This is needed by the pipeline when running the `}<strong parentName="p">{`health`}</strong>{` Task.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After the pipeline has been created, the command will set up a webhook from the Git host to the pipeline event listener.`}</p>
        <p parentName="li"><strong parentName="p">{`Note:`}</strong>{` If the webhook registration step fails it is likely because the Git credentials are incorrect or do not have enough permission in the repository.`}</p>
        <p parentName="li">{`The pipeline will be registered in your development cluster and a pipelinerun will be started.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`View your application pipeline.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`oc console
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From menu on the left switch to the `}<strong parentName="p">{`Developer`}</strong>{` mode and select the `}<em parentName="p">{`dev`}</em>{` project that was used for the application pipeline registration.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the left menu, select `}<em parentName="p">{`Pipelines`}</em>{` and click on the link to the `}<inlineCode parentName="p">{`inventory-management-svc-solution-xxxxxx`}</inlineCode>{` PipelineRun (PLR).`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Validate the REST API of the Inventory Management service is working correctly in the terminal.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`curl https://$(oc get route inventory-management-svc-solution -o jsonpath='{ .spec.host }')/api/stock-items
`}</code></pre>
        <p parentName="li">{`The response should be similar to the following output.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`[{"name":"Item 1","id":"1","stock":100,"price":10.5,"manufacturer":"Sony"},{"name":"Item 2","id":"2","stock":150,"price":100.0,"manufacturer":"Insignia"},{"name":"Item 3","id":"3","stock":10,"price":1000.0,"manufacturer":"Panasonic"},{"name":"Item 4","id":"4","stock":9,"price":990.0,"manufacturer":"JVC"}]
`}</code></pre>
      </li>
    </ol>
    <p>{`Here is a view of a completed and successful pipelinerun.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "10.416666666666668%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAW0lEQVQI1zWKSw7AIAhEe/+bKqBpqhHqYopYF5M3v4uYkHJCaw/sNagq1HTTZWYYOv5uRBfZZXb85pwTV70rlrgwpIqTgiQUKrUgcYo+S45f9kzuz7Z+a+u94wPFq5kngRuIGAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Tekton pipeline",
          "title": "Tekton pipeline",
          "src": "/dev-guide/static/c6cd842e17280517c0902bf20cb3ee86/3cbba/CNTK-Inventory-Pipeline.png",
          "srcSet": ["/dev-guide/static/c6cd842e17280517c0902bf20cb3ee86/7fc1e/CNTK-Inventory-Pipeline.png 288w", "/dev-guide/static/c6cd842e17280517c0902bf20cb3ee86/a5df1/CNTK-Inventory-Pipeline.png 576w", "/dev-guide/static/c6cd842e17280517c0902bf20cb3ee86/3cbba/CNTK-Inventory-Pipeline.png 1152w", "/dev-guide/static/c6cd842e17280517c0902bf20cb3ee86/36072/CNTK-Inventory-Pipeline.png 1667w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <h3><strong parentName="h3">{`Configure the App Connect workflow`}</strong></h3>
    <ol>
      <li parentName="ol">{`Download and install the `}<a parentName="li" {...{
          "href": "https://www.ibm.com/support/knowledgecenter/SSTTDS_11.0.0/com.ibm.etools.mft.doc/get-started-handson.html"
        }}>{`ACE Toolkit`}</a>{` and follow steps 1 and 2.`}</li>
      <li parentName="ol">{`Fork the `}<a parentName="li" {...{
          "href": "https://github.com/ibm-garage-cloud/inventory-mgmt-ace-solution"
        }}>{`inventory-mgmt-ace-solution`}</a>{` repository.  The new repository will be created in your selected organization.`}</li>
      <li parentName="ol">{`With the browser open to the newly created repository, click on `}<strong parentName="li">{`Clone or download`}</strong>{` and copy the clone `}<em parentName="li">{`SSH link`}</em>{`, and use the `}<inlineCode parentName="li">{`git clone`}</inlineCode>{` command to clone it to your developer desktop machine.`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`git clone git@github.com:{gitid}/inventory-mgmt-ace-solution.git
`}</code></pre>
      </li>
      <li parentName="ol">{`Change into the cloned directory`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`cd inventory-mgmt-ace-solution/workspace/InventoryManagementSvc
`}</code></pre>
      </li>
      <li parentName="ol">{`Obtain the URL of the Inventory Management SVC route.`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`echo $(oc get route inventory-management-svc-solution -o jsonpath='{ .spec.host }')
`}</code></pre>
      </li>
      <li parentName="ol">{`Search and replace the placeholder `}<inlineCode parentName="li">{`INVENTORY_MANAGEMENT_SVC_BASE_URL`}</inlineCode>{` with the Route URL in the `}<em parentName="li">{`listStockItemsUsingGET.subflow`}</em>{` and `}<em parentName="li">{`ace-inventory-management-svc.json`}</em>{` files.`}</li>
      <li parentName="ol">{`Commit and push the changes into your forked repository.`}</li>
    </ol>
    <h3><strong parentName="h3">{`Execute the App Connect pipeline`}</strong></h3>
    <p>{`The image below depicts the Tekton pipeline executed.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.31944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABn0lEQVQ4y62TTW/bMAyG/f9/zQrksPYwDNglh5zaHNqsHba2SRrbmSVHtL4svxVlOUiDFliBEXghkjIfiZJc7BoNSQ7G9bB+lLY9yGRpD5VF2oHIxrxP+RSzODbjN4V1AcmGAZPZCO+9i6mAU+uJQNfLHA0nM6NvfUCxqQW2+yYl6rpGVdXJv/vdQB5M+nj16xHVXkQ3wCo6oqSo0EZNUO6yeGgdlq1Jqa9Xl7i4+JJ8oQJ8P5b+uC2xrigXOWjdgfcuNt9wePmeeWEEdrH3ycqyxGazhvY2tzHgoBT2TQMhBIwx+XSGpGPD2U9AysAp2XUdZHfAy89nkFQIceXee4QQ3kB4MQ5HfQCc1MdW21bDxxvnOIQhAU8XPq/5EMjm4m1RRxHsjzm+MCnl51qeJvjZbLc7kKJjkc9tn+/yn4C8w79UobOE2WyGJl7KfD7HYrFI89N5vt+yHoGBz2oYD9o4D6kFWiVxc7NMb/P+/gF3q1UGvoWFPCYg7+Z/GS9U/NkplEKD/2lWGbWuCY+lwnN8zE9xfOKxUsnn3LvKNa9+w/VBqev9KwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Tekton pipeline",
        "title": "Tekton pipeline",
        "src": "/dev-guide/static/06c323f9d024e234b9617b4f6dcc8536/3cbba/CNTK-ACE-Pipelines_v1.0-ACE-App.png",
        "srcSet": ["/dev-guide/static/06c323f9d024e234b9617b4f6dcc8536/7fc1e/CNTK-ACE-Pipelines_v1.0-ACE-App.png 288w", "/dev-guide/static/06c323f9d024e234b9617b4f6dcc8536/a5df1/CNTK-ACE-Pipelines_v1.0-ACE-App.png 576w", "/dev-guide/static/06c323f9d024e234b9617b4f6dcc8536/3cbba/CNTK-ACE-Pipelines_v1.0-ACE-App.png 1152w", "/dev-guide/static/06c323f9d024e234b9617b4f6dcc8536/e8601/CNTK-ACE-Pipelines_v1.0-ACE-App.png 1493w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create a Secret containing the IBM Entitled Registry credentials to pull the ACE image for the CI process in the pipeline.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`oc create secret generic ibm-entitled-registry --type="kubernetes.io/basic-auth" --from-literal=username=cp --from-literal=password=<IBM Entitlement Key>
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Register the App in a DevOps Pipeline`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`  oc pipeline
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the `}<inlineCode parentName="p">{`Tekton`}</inlineCode>{` pipeline type.  You should not be prompted for Git credentials as a Secret already exists with your username and token.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When registering a `}<inlineCode parentName="p">{`Tekton`}</inlineCode>{` pipeline, you will also be prompted to select which pipeline you want to use for your application. Select `}<inlineCode parentName="p">{`ibm-ace-bar`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Y`}</inlineCode>{`/`}<inlineCode parentName="p">{`n`}</inlineCode>{` to enable the pipeline to scan the image for vulnerabilities.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Provide `}<inlineCode parentName="p">{`/api/stock-items`}</inlineCode>{` as the health endpoint.  This is needed by the pipeline when running the `}<strong parentName="p">{`health`}</strong>{` Task.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After the pipeline has been created, the command will set up a webhook from the Git host to the pipeline event listener`}</p>
        <p parentName="li"><strong parentName="p">{`Note:`}</strong>{` If the webhook registration step fails it is likely because the Git credentials are incorrect or do not have enough permission in the repository.`}</p>
        <p parentName="li">{`The pipeline will be registered in your development cluster.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`View your application pipeline`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`oc console
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From menu on the left switch to the `}<strong parentName="p">{`Developer`}</strong>{` mode and select `}<em parentName="p">{`dev`}</em>{` project that was used for the application pipeline registration.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the left menu, select `}<em parentName="p">{`Pipelines`}</em>{` and click on the link to the `}<inlineCode parentName="p">{`inventory-mgmt-ace-solution-xxxxxx`}</inlineCode>{` PipelineRun (PLR).`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Validate the App Connect server is working correctly in the terminal.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`curl http://$(oc get route inventory-mgmt-ace-solution-http -o jsonpath='{ .spec.host }')/api/stock-items
`}</code></pre>
        <p parentName="li">{`The response should be similar to the following output.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`[{"name":"Item 1","id":"1","stock":100,"price":10.5,"manufacturer":"Sony"},{"name":"Item 2","id":"2","stock":150,"price":100.0,"manufacturer":"Insignia"},{"name":"Item 3","id":"3","stock":10,"price":1000.0,"manufacturer":"Panasonic"},{"name":"Item 4","id":"4","stock":9,"price":990.0,"manufacturer":"JVC"}]
`}</code></pre>
      </li>
    </ol>
    <p>{`Here is a view of a completed and successful pipelinerun.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "12.847222222222221%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAf0lEQVQI12XO0Q7DIAgFUP//O9fZIirog2ui3qnLmnR7IDecAMFYa3G+TrTWVvXWUWu98tf+5nq/+pmmlALrnkg5gYPDwTtyzthoW+aG7WShqstijCBPICZoGnY8ls29uW80Cbx4RA1rYOJMH78m6+jHGEECRAUcHVIaT9yM8QY9QeZM2UlG5gAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Tekton pipeline",
          "title": "Tekton pipeline",
          "src": "/dev-guide/static/e4c8790bb6d61570138ae7c75bf87d44/3cbba/CNTK-ACE-Pipeline.png",
          "srcSet": ["/dev-guide/static/e4c8790bb6d61570138ae7c75bf87d44/7fc1e/CNTK-ACE-Pipeline.png 288w", "/dev-guide/static/e4c8790bb6d61570138ae7c75bf87d44/a5df1/CNTK-ACE-Pipeline.png 576w", "/dev-guide/static/e4c8790bb6d61570138ae7c75bf87d44/3cbba/CNTK-ACE-Pipeline.png 1152w", "/dev-guide/static/e4c8790bb6d61570138ae7c75bf87d44/66010/CNTK-ACE-Pipeline.png 1377w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      